
import React from "react";
import { BaseService, HostService, IHost, IHostWebsite, IMember, SanitizedResponse } from "../../../../services";
import PageDesign from "../../../page_design/PageDesign";
import { i18nManager } from "../../../../i18n";
import { Siren } from "../../../shared/ConfirmDialog";
import { Capability } from "../../../../utils";

export interface DesignProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function Design(props: DesignProps) {

    const hostService = HostService.getInstance();
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);

    return (<div className="profile-settings team-settings"><PageDesign capability={Capability.CHANGE_HOST_WEBSITE_DESIGN} publicId={props.host.public_id} designType={"host"} activeDesign={props.hostWebsite.website_design_settings} onUpdate={updateDesign} /></div>);

    function updateDesign(pageDesign: any, onDone?: () => void) {
        if (!hostWebsite) return onDone?.();
        hostWebsite.website_design_settings = pageDesign;
        hostService.updateHostWebsite(props.host.external_id, { ...hostWebsite }).then(({ sanitized }: SanitizedResponse<IHostWebsite>) => {
            setHostWebsite(sanitized);
            Siren.alert(i18nManager.Labels.host.settings.website.design_update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Design;
